/* eslint-disable react-hooks/exhaustive-deps */
import moment from 'moment-timezone'
import React, { useEffect, useImperativeHandle, useState } from 'react'

import globalNotification from 'live/services/global-notification'
import i18n from 'live/services/i18n'

import {
    exportResourceBarrierAnalysis,
    exportResourceThreatStatus,
    getResourceBarrierAnalysis,
    getResourceBarrierAnalysisGraph
} from 'plugin-codaf-risk-ext-bowtie/services/reportEvents'
import { IBarrierStatusSpecialStatus } from 'plugin-codaf-risk-ext-bowtie/types'
import { OrderFields } from 'plugin-codaf-risk-ext-bowtie/types/enums'
import {
    IResourceBarrierAnalysisGraphic,
    IResourceBarrierAnalysisReport
} from 'plugin-codaf-risk-ext-bowtie/types/reports'

import { NoData, NoInfo } from '../../styles'
import { ReportPopover } from '../ReportFilter/ReportPopover'
import { ReportGraph } from '../ReportGraph/ReportGraph'

interface IProps {
    setItemsLength: (k: number) => void
    start: number
    numberOfItems: number
    time: string | null
    startDay: string | null
    endDay: string | null
    startHour: string | null
    endHour: string | null
    page: number
    setPage: (k: number) => void
    dictionaryStatusMap: Map<number, IBarrierStatusSpecialStatus>
    setExportLoading: (k: boolean) => void
}

interface IOrder {
    field: string
    order: boolean
}

interface IBarrierDataToGraph {
    barrierId: number
    barrierName: string
}

export const ResourceBarrierAnalysis = React.forwardRef<any, IProps>(function ResourceBarrierAnalysis(
    {
        setItemsLength,
        numberOfItems,
        startDay,
        startHour,
        endDay,
        endHour,
        page,
        setPage,
        dictionaryStatusMap,
        setExportLoading
    },
    ref
) {
    const [isLoading, setIsLoading] = useState(false)
    const [loadingGraph, setLoadingGraph] = useState(false)

    const [order, setOrder] = useState<IOrder>({ field: OrderFields.DATE, order: true })

    const [searchResource, setSearchResource] = useState<string>('')
    const [listResource, setListResource] = useState(new Set<string>())
    const [filterResource, setFilterResource] = useState(new Set<string>())

    const [searchBowtieCode, setSearchBowtieCode] = useState<string>('')
    const [listBowtieCode, setListBowtieCode] = useState(new Set<string>())
    const [filterBowtieCode, setFilterBowtieCode] = useState(new Set<string>())

    const [searchBarrierId, setSearchBarrierId] = useState<string>('')
    const [listBarrierId, setListBarrierId] = useState(new Set<string>())
    const [filterBarrierId, setFilterBarrierId] = useState(new Set<string>())

    const [searchBarrierName, setSearchBarrierName] = useState<string>('')
    const [listBarrierName, setListBarrierName] = useState(new Set<string>())
    const [filterBarrierName, setFilterBarrierName] = useState(new Set<string>())

    const [searchSystemId, setSearchSystemId] = useState<string>('')
    const [listSystemId, setListSystemId] = useState(new Set<string>())
    const [filterSystemId, setFilterSystemId] = useState(new Set<string>())

    // const [searchCategory, setSearchCategory] = useState<string>('')
    // const [listCategory, setListCategory] = useState(new Set<string>())
    const [filterCategory] = useState(new Set<string>())

    const [searchStatus, setSearchStatus] = useState<string>('')
    const [listStatus, setListStatus] = useState(new Set<string>())
    const [filterStatus, setFilterStatus] = useState(new Set<string>())

    const [searchResponsible, setSearchResponsible] = useState<string>('')
    const [listResponsible, setListResponsible] = useState(new Set<string>())
    const [filterResponsible, setFilterResponsible] = useState(new Set<string>())

    const [searchDate, setSearchDate] = useState<string>('')
    const [listDate, setListDate] = useState(new Set<string>())
    const [filterDate, setFilterDate] = useState(new Set<string>())

    const [searchTimeInterval, setSearchTimeInterval] = useState<string>('')
    const [listTimeInterval, setListTimeInterval] = useState(new Set<string>())
    const [filterTimeInterval, setFilterTimeInterval] = useState(new Set<string>())

    const [searchTimeGathred, setSearchTimeGathred] = useState<string>('')
    const [listTimeGathred, setListTimeGathred] = useState(new Set<string>())
    const [filterTimeGathred, setFilterTimeGathred] = useState(new Set<string>())

    const [graphicData, setGraphicData] = useState<IResourceBarrierAnalysisGraphic>()
    const [graphicName, setGraphicName] = useState<IBarrierDataToGraph>({ barrierId: 0, barrierName: '' })
    const [events, setEvents] = useState<IResourceBarrierAnalysisReport>()

    const [selected, setSelected] = useState<number>()

    const [update, setUpdate] = useState<number>(0)

    const dateConverter = (data): string => {
        const newDate = new Date(data)
        const converted = moment(newDate).format('YYYY/MM/DD, hh:mm:ss a')

        return `${converted}`
    }

    const calcInterval = (ts, finalTs): string => {
        const timeRemain = finalTs - ts
        const second = 1000
        const minute = second * 60
        const hour = minute * 60
        const hours = timeRemain / hour
        const minutes = (timeRemain % hour) / minute
        const seconds = ((timeRemain % hour) % minute) / second

        return `${Math.floor(hours)}h ${minutes < 10 ? `0${Math.floor(minutes)}` : Math.floor(minutes)}m ${
            seconds < 10 ? `0${Math.floor(seconds)}` : Math.floor(seconds)
        }s`
    }

    const calcITotalTime = (ts): string => {
        const timeRemain = ts
        const second = 1000
        const minute = second * 60
        const hour = minute * 60
        const hours = timeRemain / hour
        const minutes = (timeRemain % hour) / minute
        const seconds = ((timeRemain % hour) % minute) / second

        return `${Math.floor(hours)}h ${minutes < 10 ? `0${Math.floor(minutes)}` : Math.floor(minutes)}m ${
            seconds < 10 ? `0${Math.floor(seconds)}` : Math.floor(seconds)
        }s`
    }

    const formatSetToArray = (setToFormat: Set<string>): string[] => {
        const arr = []
        setToFormat.forEach(item => {
            arr.push(item)
        })

        return arr
    }

    const renderTableRow = (): JSX.Element[] => {
        if (events?.reportEvent) {
            const renderObject = events?.reportEvent.map((item, index) => {
                return (
                    <tr
                        key={index}
                        className={`${
                            selected === index ? 'trWithGraph trSelected' : 'trWithGraph'
                        } resource-barrier-analysis ${index === 0 ? 'first-margin' : ''}`}
                    >
                        <td valign="middle" className={'common-width'}>
                            <button
                                className="toGraph"
                                onClick={() => {
                                    setGraphicName({ barrierId: item.barrierId, barrierName: item.barrierName })
                                    setSelected(index)
                                }}
                            >
                                {item.resource}
                            </button>
                        </td>
                        <td valign="middle" className={'common-width'}>
                            <button
                                className="toGraph"
                                onClick={() => {
                                    setGraphicName({ barrierId: item.barrierId, barrierName: item.barrierName })
                                    setSelected(index)
                                }}
                            >
                                {item.bowtieCode}
                            </button>
                        </td>
                        <td valign="middle" className={'common-width'}>
                            <button
                                className="toGraph"
                                onClick={() => {
                                    setGraphicName({ barrierId: item.barrierId, barrierName: item.barrierName })
                                    setSelected(index)
                                }}
                            >
                                {item.barrierId}
                            </button>
                        </td>
                        <td valign="middle" className={'common-width'}>
                            <button
                                className="toGraph"
                                onClick={() => {
                                    setGraphicName({ barrierId: item.barrierId, barrierName: item.barrierName })
                                    setSelected(index)
                                }}
                            >
                                {item.barrierName}
                            </button>
                        </td>
                        <td valign="middle" className={'common-width'}>
                            <button
                                className="toGraph"
                                onClick={() => {
                                    setGraphicName({ barrierId: item.barrierId, barrierName: item.barrierName })
                                    setSelected(index)
                                }}
                            >
                                <span>{item.systemId}</span>
                            </button>
                        </td>
                        <td valign="middle" className={'common-width'}>
                            <button
                                className="toGraph"
                                onClick={() => {
                                    setGraphicName({ barrierId: item.barrierId, barrierName: item.barrierName })
                                    setSelected(index)
                                }}
                            >
                                <span>{item.responsible}</span>
                            </button>
                        </td>
                        <td valign="middle" className={'common-width'}>
                            <button
                                className="toGraph"
                                onClick={() => {
                                    setGraphicName({ barrierId: item.barrierId, barrierName: item.barrierName })
                                    setSelected(index)
                                }}
                            >
                                <span className={`barrierStatus ${item.status}`} style={{ color: item.statusColor }}>
                                    {item.status}
                                </span>
                            </button>
                        </td>
                        <td valign="middle" className={'common-width'}>
                            <button
                                className="toGraph"
                                onClick={() => {
                                    setGraphicName({ barrierId: item.barrierId, barrierName: item.barrierName })
                                    setSelected(index)
                                }}
                            >
                                {`${dateConverter(item.date)} ${i18n('to')} ${dateConverter(item.finalDate)}`}
                            </button>
                        </td>
                        <td valign="middle" className={'common-width'}>
                            <button
                                className="toGraph"
                                onClick={() => {
                                    setGraphicName({ barrierId: item.barrierId, barrierName: item.barrierName })
                                    setSelected(index)
                                }}
                            >
                                <span className="timeGathred">{calcInterval(item.date, item.finalDate)}</span>
                            </button>
                        </td>
                        <td valign="middle" className={'common-width'}>
                            <button
                                className="toGraph"
                                onClick={() => {
                                    setGraphicName({ barrierId: item.barrierId, barrierName: item.barrierName })
                                    setSelected(index)
                                }}
                            >
                                <span className="timeGathred">{calcITotalTime(item.totalTime)}</span>
                            </button>
                        </td>
                    </tr>
                )
            })

            return renderObject
        }
    }

    const dateFormatToRequisition = (dateToConvert): string => {
        const initialDateToRequisition = new Date(dateToConvert)
        const formatedInitialDate = moment(initialDateToRequisition).format('YYYY-MM-DD')

        return formatedInitialDate
    }

    const getEvents = async (): Promise<void> => {
        try {
            setIsLoading(true)
            const barrierAnalysisEvents = await getResourceBarrierAnalysis({
                startDay: dateFormatToRequisition(startDay),
                startHour: startHour,
                endDay: dateFormatToRequisition(endDay),
                endHour: endHour,
                page: page,
                perPage: numberOfItems,
                sortBy: order.field,
                sortOrder: order.order ? 'ASC' : 'DESC',
                filterByResource: filterResource.size > 0 && formatSetToArray(filterResource),
                filterByBowtieCode: filterBowtieCode.size > 0 && formatSetToArray(filterBowtieCode),
                filterByBarrierId: filterBarrierId.size > 0 && formatSetToArray(filterBarrierId),
                filterByBarrierName: filterBarrierName.size > 0 && formatSetToArray(filterBarrierName),
                filterBySystemId: filterSystemId.size > 0 && formatSetToArray(filterSystemId),
                filterByCategory: filterCategory.size > 0 && formatSetToArray(filterCategory),
                filterByStatus: filterStatus.size > 0 && formatSetToArray(filterStatus),
                filterByResponsible: filterResponsible.size > 0 && formatSetToArray(filterResponsible)
            })
            setEvents(barrierAnalysisEvents)
            setItemsLength(barrierAnalysisEvents.total)
        } catch (err) {
            globalNotification.error(err.message ?? i18n('An error occurred on list events.'))
        } finally {
            setIsLoading(false)
        }
    }

    const handleGraphData = async (): Promise<void> => {
        try {
            setLoadingGraph(true)
            const barrierAnalysisGraphic = await getResourceBarrierAnalysisGraph({
                startDay: dateFormatToRequisition(startDay),
                startHour: startHour,
                endDay: dateFormatToRequisition(endDay),
                endHour: endHour,
                filterByUniqueId: graphicName.barrierId.toString()
            })
            setGraphicData(barrierAnalysisGraphic)
        } catch (err) {
            globalNotification.error(err.message ?? i18n('An error occurred on list events.'))
        } finally {
            setLoadingGraph(false)
        }
    }

    const onClearAllFilters = (): void => {
        setUpdate(update + 1)
        globalNotification.success(i18n('Filters removed successfully.'))
    }

    useImperativeHandle(ref, () => ({
        async exportResourceBarrierAnalysis() {
            try {
                setExportLoading(true)
                await exportResourceBarrierAnalysis({
                    startDay: dateFormatToRequisition(startDay),
                    startHour: startHour,
                    endDay: dateFormatToRequisition(endDay),
                    endHour: endHour,
                    sortBy: order.field,
                    sortOrder: order.order ? 'ASC' : 'DESC',
                    filterByResource: filterResource.size > 0 && formatSetToArray(filterResource),
                    filterByBowtieCode: filterBowtieCode.size > 0 && formatSetToArray(filterBowtieCode),
                    filterByBarrierId: filterBarrierId.size > 0 && formatSetToArray(filterBarrierId),
                    filterByBarrierName: filterBarrierName.size > 0 && formatSetToArray(filterBarrierName),
                    filterBySystemId: filterSystemId.size > 0 && formatSetToArray(filterSystemId),
                    filterByCategory: filterCategory.size > 0 && formatSetToArray(filterCategory),
                    filterByStatus: filterStatus.size > 0 && formatSetToArray(filterStatus),
                    filterByResponsible: filterResponsible.size > 0 && formatSetToArray(filterResponsible)
                })
                globalNotification.success(i18n('Report exported successfully.'))
            } catch (error) {
                globalNotification.error(i18n('Error on exporting report.'))
            } finally {
                setExportLoading(false)
            }
        }
    }))

    useEffect(() => {
        getEvents()
    }, [
        startDay,
        startHour,
        endDay,
        endHour,
        page,
        order,
        filterResource,
        filterBowtieCode,
        filterBarrierId,
        filterBarrierName,
        filterDate,
        filterCategory,
        filterTimeInterval,
        filterTimeGathred,
        filterStatus,
        filterResponsible,
        filterSystemId
    ])

    useEffect(() => {
        handleGraphData()
    }, [graphicName])

    useEffect(() => {
        setPage(1)
    }, [
        order,
        filterResource,
        filterBowtieCode,
        filterBarrierId,
        filterBarrierName,
        filterDate,
        filterCategory,
        filterTimeInterval,
        filterTimeGathred,
        filterStatus,
        filterSystemId
    ])

    return (
        <>
            <button className="clearAllFilters" onClick={() => onClearAllFilters()}>
                {i18n('Clear all filter view')}
                <i className="far fa-filter"></i>
            </button>
            <div className="tableContainerWithGraphic customScroll">
                <table>
                    <thead className="tableHeader">
                        <tr className="resource-barrier-analysis-header">
                            <th className={'common-width'}>
                                <ReportPopover
                                    search={searchResource}
                                    setSearch={setSearchResource}
                                    order={order}
                                    setOrder={setOrder}
                                    field={OrderFields.RESOURCE}
                                    list={listResource}
                                    setList={setListResource}
                                    filter={filterResource}
                                    setFilter={setFilterResource}
                                    onClearAll={update}
                                    buttonTitle={'resource'}
                                />
                            </th>
                            <th className={'common-width'}>
                                <ReportPopover
                                    search={searchBowtieCode}
                                    setSearch={setSearchBowtieCode}
                                    order={order}
                                    setOrder={setOrder}
                                    field={OrderFields.BOWTIECODE}
                                    list={listBowtieCode}
                                    setList={setListBowtieCode}
                                    filter={filterBowtieCode}
                                    setFilter={setFilterBowtieCode}
                                    onClearAll={update}
                                    buttonTitle="bowtie code"
                                />
                            </th>
                            <th className={'common-width'}>
                                <ReportPopover
                                    search={searchBarrierId}
                                    setSearch={setSearchBarrierId}
                                    order={order}
                                    setOrder={setOrder}
                                    field={OrderFields.BARRIER_ID}
                                    list={listBarrierId}
                                    setList={setListBarrierId}
                                    filter={filterBarrierId}
                                    setFilter={setFilterBarrierId}
                                    onClearAll={update}
                                    buttonTitle="barrier id"
                                />
                            </th>
                            <th className={'common-width'}>
                                <ReportPopover
                                    search={searchBarrierName}
                                    setSearch={setSearchBarrierName}
                                    order={order}
                                    setOrder={setOrder}
                                    field={OrderFields.BARRIER_NAME}
                                    list={listBarrierName}
                                    setList={setListBarrierName}
                                    filter={filterBarrierName}
                                    setFilter={setFilterBarrierName}
                                    onClearAll={update}
                                    buttonTitle="barrier name"
                                />
                            </th>
                            <th className={'common-width'}>
                                <ReportPopover
                                    search={searchSystemId}
                                    setSearch={setSearchSystemId}
                                    order={order}
                                    setOrder={setOrder}
                                    field={OrderFields.SYSTEM_ID}
                                    list={listSystemId}
                                    setList={setListSystemId}
                                    filter={filterSystemId}
                                    setFilter={setFilterSystemId}
                                    onClearAll={update}
                                    buttonTitle="Live Event ID"
                                />
                            </th>
                            <th className={'common-width'}>
                                <ReportPopover
                                    search={searchResponsible}
                                    setSearch={setSearchResponsible}
                                    order={order}
                                    setOrder={setOrder}
                                    field={OrderFields.RESPONSIBLE}
                                    list={listResponsible}
                                    setList={setListResponsible}
                                    filter={filterResponsible}
                                    setFilter={setFilterResponsible}
                                    onClearAll={update}
                                    buttonTitle="Responsible"
                                />
                            </th>
                            <th className={'common-width'}>
                                <ReportPopover
                                    search={searchStatus}
                                    setSearch={setSearchStatus}
                                    order={order}
                                    setOrder={setOrder}
                                    field={OrderFields.STATUS}
                                    list={listStatus}
                                    setList={setListStatus}
                                    filter={filterStatus}
                                    setFilter={setFilterStatus}
                                    onClearAll={update}
                                    buttonTitle="status"
                                />
                            </th>
                            <th className={'common-width'}>
                                <ReportPopover
                                    search={searchDate}
                                    setSearch={setSearchDate}
                                    order={order}
                                    setOrder={setOrder}
                                    field={OrderFields.DATE}
                                    list={listDate}
                                    setList={setListDate}
                                    filter={filterDate}
                                    setFilter={setFilterDate}
                                    onClearAll={update}
                                    buttonTitle="date/time"
                                />
                            </th>
                            <th className={'common-width'}>
                                <ReportPopover
                                    search={searchTimeInterval}
                                    setSearch={setSearchTimeInterval}
                                    order={order}
                                    setOrder={setOrder}
                                    field={OrderFields.TIME_INTERVAL}
                                    list={listTimeInterval}
                                    setList={setListTimeInterval}
                                    filter={filterTimeInterval}
                                    setFilter={setFilterTimeInterval}
                                    onClearAll={update}
                                    buttonTitle="time interval"
                                />
                            </th>
                            <th className={'common-width'}>
                                <ReportPopover
                                    search={searchTimeGathred}
                                    setSearch={setSearchTimeGathred}
                                    order={order}
                                    setOrder={setOrder}
                                    field={OrderFields.TIME_GATHERED}
                                    list={listTimeGathred}
                                    setList={setListTimeGathred}
                                    filter={filterTimeGathred}
                                    setFilter={setFilterTimeGathred}
                                    onClearAll={update}
                                    buttonTitle="time gathered"
                                    last
                                />
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {isLoading ? (
                            <NoInfo>
                                <i className="fa fa-spinner fa-spin" />
                            </NoInfo>
                        ) : events?.total === 0 ? (
                            <NoData>{i18n('There is no data for the specified period.')}</NoData>
                        ) : (
                            renderTableRow()
                        )}
                    </tbody>
                </table>
            </div>
            <ReportGraph
                loading={loadingGraph}
                data={graphicData}
                description={graphicName}
                dictionaryStatusMap={dictionaryStatusMap}
            />
        </>
    )
})
